// extracted by mini-css-extract-plugin
export default {"container":"style_container__Mtl3l","body":"style_body__9KOkE","conclusion":"style_conclusion__3817a","smallCard":"style_smallCard__hQiIS","btn":"style_btn__eXVLP"};